Ctrl.$inject = ['$scope', '$state', '$stateParams', 'Authentication', 'Analytics', '$rootScope', 'Localization', '$timeout', '$window'];

function Ctrl($scope, $state, $stateParams, Authentication, Analytics, $rootScope, Localization, $timeout, $window) {
	$scope.recoveryStep = '';
	$scope.preLoader = false;
	$scope.smsSender = {};
	$scope.init = function () {
		$scope.loginStep = 'login';
	};

	var focusReturnTarget = $stateParams.focusBack || null;

	try {
		if (focusReturnTarget) {
			$window.sessionStorage.setItem('focusReturn', focusReturnTarget);
		}
	} catch (e) {}

	$timeout(function () {
		var heading = document.getElementById('login-form-title');
		if (heading && typeof heading.focus === 'function') {
			heading.focus();
		}
	}, 0);

	if ($rootScope.useFrame && $state.current.data.iframe == false) {
		document.body.classList.remove('bodyContainer');
		$state.go('pages.error404');
		$rootScope.useFrame = false;
	}

	$scope.activeSliderFormPreLoader = function (active) {
		$scope.preLoader = active || false;
	};

	$scope.login = function (form) {
		if (form.$invalid) {
			if (!form.email || !form.email.$valid) {
				Localization.notifyTemplate('error', 'ERRORS.INCORRECT_LOGIN', 5, true);
				return;
			}
			if (!form.password.$valid) {
				Localization.notifyTemplate('error', 'ERRORS.INVALID_PASSWORD', 5, true);
				if (form.password.$viewValue && !form.password.$valid) {
					$state.go('pages.password-recovery');
				}
				return;
			}
		}

		$scope.preLoader = true;

		var loginData = {
			email: form.email.$modelValue,
			password: form.password.$modelValue
		};

		Authentication.login(loginData).then(
			function () {

				if ($stateParams.registration === true) {
					Analytics.trackEvent(
						'Регистрация',
						'Успешно',
						'Авторизировался'
					);
					Analytics.pageView();
				}

				$state.go('pages.services', {categoryId: 'all'});
			},
			function () {
				Localization.notifyTemplate('error', 'ERRORS.AUTH_ERROR', 5, true);
			}
		).finally(function () {
			$scope.preLoader = false;
		});
	};

	$scope.cancel = function () {
		try {
			if (focusReturnTarget) {
				$window.sessionStorage.setItem('focusReturn', focusReturnTarget);
			}
		} catch (e) {}

		$state.go('pages.main');
	};

	$scope.init();
}

module.exports = Ctrl;



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/login/controllers/login.js
 ** module id = 264
 ** module chunks = 1
 **/